export default "__VITE_ASSET__UKXgbHKL__"